(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["h433-bundle-script"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('h433-bundle')) {
    customElements.define(
      'h433-bundle',
      class H433Bundle extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;
          this.root = this.dataset.root || '/';
          if (!this.root.endsWith('/')) this.root += '/';
          this.money = JSON.parse(this.querySelector('[data-money]')?.textContent || '"${{amount}}"');
          this.current = JSON.parse(this.querySelector('[data-current]').textContent);
          this.cache = {};
          this.products = {};
          this.target = 0;

          const v0 = this.current.variants.find((v) => v.id === this.current.selected) || this.current.variants[0];
          // Jersey de esta página (siempre cuenta), jerseys ya en el carrito y jerseys nuevos elegidos aquí
          this.page = {
            product: {
              id: this.current.id,
              title: this.current.title,
              url: this.current.url,
              image: this.current.image,
              options: this.current.options,
              variants: this.current.variants,
            },
            variantId: v0 ? v0.id : null,
          };
          this.picks = [];
          this.cartUnits = [];
          this.productCache = {};
          this.showCart = this.dataset.showCart !== 'false';

          this.dialog = this.querySelector('[data-dialog]');
          this.results = this.querySelector('[data-results]');
          this.status = this.querySelector('[data-status]');
          this.moreButton = this.querySelector('[data-load-more]');
          this.browse = this.querySelector('[data-browse]');
          this.config = this.querySelector('[data-config]');
          this.scroller = this.querySelector('[data-scroll]');
          this.searchInput = this.querySelector('[data-search]');
          this.cta = this.querySelector('[data-cta]');

          this.addEventListener('click', (e) => this.onClick(e));
          this.addEventListener('change', (e) => this.onChange(e));
          this.querySelector('[data-search-form]')?.addEventListener('submit', (e) => {
            e.preventDefault();
            clearTimeout(this.searchTimer);
            this.renderResults();
          });
          this.searchInput?.addEventListener('input', () => {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => this.renderResults(), 350);
          });
          // Las tarjetas son las mismas de la página de resultados: aquí se intercepta su botón
          // "Agregar" (y sus enlaces) para pedir talla / manga en lugar de ir al carrito.
          this.dialog?.addEventListener('click', (e) => this.onPickerClick(e), true);
          this.dialog?.addEventListener('click', (e) => {
            if (e.target === this.dialog) this.closePicker();
          });
          this.dialog?.addEventListener('close', () => {
            document.documentElement.classList.remove('h433-bpick-open');
          });

          // Mantener sincronizado con el selector de talla normal del producto si existe
          document.addEventListener('variant:update', (e) => {
            const id = Number(e.detail?.resource?.id);
            if (id && this.page.product.variants.some((v) => v.id === id)) {
              this.page.variantId = id;
              this.render();
            }
          });

          // Jerseys que ya están en el carrito
          this.onCartUpdate = () => {
            clearTimeout(this.cartTimer);
            this.cartTimer = setTimeout(() => this.loadCart(), 150);
          };
          document.addEventListener('cart:update', this.onCartUpdate);

          this.render();
          this.loadCart();
        }

        disconnectedCallback() {
          document.removeEventListener('cart:update', this.onCartUpdate);
        }

        async loadCart() {
          if (!this.showCart) return;
          try {
            const cart = await fetch(`${this.root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
            const units = [];
            (cart.items || []).forEach((item) => {
              if (item.gift_card) return;
              for (let q = 0; q < item.quantity; q++) units.push({ item });
            });
            this.cartUnits = units;
            this.render();
            await this.loadCartProducts();
          } catch (e) {
            /* si falla, conserva lo último */
          }
        }

        /** Tallas de los jerseys del carrito (para poder cambiarlas desde el recuadro) */
        async loadCartProducts() {
          const handles = [...new Set(this.cartUnits.map((u) => u.item.handle).filter(Boolean))].filter(
            (h) => !this.productCache[h]
          );
          if (!handles.length) return;
          await Promise.all(
            handles.map((h) =>
              fetch(`${this.root}products/${h}.js`, { headers: { Accept: 'application/json' } })
                .then((r) => (r.ok ? r.json() : null))
                .then((p) => {
                  if (!p) return;
                  this.productCache[h] = {
                    variants: (p.variants || []).map((v) => ({
                      id: v.id,
                      title: v.title,
                      price: v.price,
                      available: v.available !== false,
                    })),
                  };
                })
                .catch(() => {})
            )
          );
          this.render();
        }

        async changeCartVariant(key, newId, select) {
          const unit = this.cartUnits.find((u) => u.item.key === key);
          if (!unit || !newId || newId === unit.item.variant_id || this.busy) return;
          this.busy = true;
          if (select) select.disabled = true;
          const sections = this.sectionIds();
          const post = (url, body) =>
            fetch(`${this.root}${url}`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(body),
            }).then(async (r) => {
              const data = await r.json();
              if (!r.ok || data.status) throw new Error(data.description || data.message || 'No se pudo cambiar la talla');
              return data;
            });
          try {
            await post('cart/change.js', { id: key, quantity: Math.max(unit.item.quantity - 1, 0) });
            const data = await post('cart/add.js', {
              items: [{ id: newId, quantity: 1 }],
              ...(sections.length ? { sections: sections.join(',') } : {}),
            });
            const event = new Event('cart:update', { bubbles: true });
            event.detail = {
              resource: {},
              sourceId: String(newId),
              data: {
                source: 'h433-bundle-size',
                itemCount: this.cartUnits.length,
                productId: String(unit.item.product_id),
                variantId: String(newId),
                sections: data.sections || {},
              },
            };
            this.dispatchSilently(event);
          } catch (error) {
            this.showMessage(error.message);
            this.loadCart();
          } finally {
            this.busy = false;
          }
        }

        /**
         * Avisa al tema que el carrito cambió (contador, carrito lateral, barra de progreso)
         * sin abrir el carrito lateral: apaga su apertura automática solo durante el aviso.
         */
        dispatchSilently(event) {
          const drawers = Array.from(document.querySelectorAll('cart-drawer-component[auto-open]')).map((el) => [
            el,
            el.getAttribute('auto-open'),
          ]);
          drawers.forEach(([el]) => el.removeAttribute('auto-open'));
          try {
            this.dispatchEvent(event);
          } finally {
            drawers.forEach(([el, value]) => el.setAttribute('auto-open', value ?? ''));
          }
        }

        async removeFromCart(key, button) {
          const unit = this.cartUnits.find((u) => u.item.key === key);
          if (!unit || this.busy) return;
          this.busy = true;
          if (button) button.disabled = true;
          const sections = this.sectionIds();
          try {
            const res = await fetch(`${this.root}cart/change.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                id: key,
                quantity: Math.max(unit.item.quantity - 1, 0),
                ...(sections.length ? { sections: sections.join(',') } : {}),
              }),
            });
            const data = await res.json();
            if (!res.ok || data.status) throw new Error(data.description || data.message || 'No se pudo quitar');
            const event = new Event('cart:update', { bubbles: true });
            event.detail = {
              resource: data,
              sourceId: String(unit.item.variant_id),
              data: {
                source: 'h433-bundle-remove',
                itemCount: data.item_count,
                productId: String(unit.item.product_id),
                variantId: String(unit.item.variant_id),
                sections: data.sections || {},
              },
            };
            this.dispatchSilently(event);
          } catch (error) {
            this.showMessage(error.message);
            if (button) button.disabled = false;
          } finally {
            this.busy = false;
          }
        }

        /* ---------- utilidades ---------- */
        formatMoney(cents) {
          const value = (Number(cents) || 0) / 100;
          const fmt = (n, dec, thou, decSep) => {
            const parts = n.toFixed(dec).split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
            return parts.join(decSep);
          };
          return this.money.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
            switch (key) {
              case 'amount_no_decimals':
                return fmt(value, 0, ',', '.');
              case 'amount_with_comma_separator':
                return fmt(value, 2, '.', ',');
              case 'amount_no_decimals_with_comma_separator':
                return fmt(value, 0, '.', ',');
              default:
                return fmt(value, 2, ',', '.');
            }
          });
        }

        text(key, n, amount) {
          return (this.dataset[key] || '').replace('[n]', n).replace('[monto]', amount || '');
        }

        esc(str) {
          return (str == null ? '' : String(str)).replace(
            /[<>&"]/g,
            (c) => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' })[c]
          );
        }

        sized(src, width) {
          if (!src) return '';
          try {
            const url = new URL(src, location.origin);
            url.searchParams.set('width', width);
            return url.toString();
          } catch (e) {
            return src;
          }
        }

        /** closest() que nunca devuelve el propio recuadro (tiene atributos data-* parecidos) */
        hit(target, selector) {
          const el = target.closest(selector);
          return el && el !== this && this.contains(el) ? el : null;
        }

        /* ---------- resultados (Section Rendering API) ---------- */
        withSection(url) {
          const u = new URL(url, location.origin);
          u.searchParams.set('section_id', 'h433-bundle-results');
          return u.pathname + u.search;
        }

        urlFor(source, term) {
          if (term) {
            return this.withSection(
              `${this.root}search?q=${encodeURIComponent(term)}&type=product&options%5Bprefix%5D=last`
            );
          }
          if (source === 'recommended') {
            return this.withSection(
              `${this.root}recommendations/products?product_id=${this.dataset.productId}&limit=12&intent=related`
            );
          }
          const handle = (source || '').split(':')[1] || this.dataset.all || 'all';
          return this.withSection(`${this.root}collections/${handle}`);
        }

        async fetchPage(url) {
          if (!this.cache[url]) {
            this.cache[url] = fetch(url)
              .then((r) => {
                if (!r.ok) throw new Error(r.status);
                return r.text();
              })
              .catch((e) => {
                delete this.cache[url];
                throw e;
              });
          }
          const html = new DOMParser().parseFromString(await this.cache[url], 'text/html');
          const items = [];
          html.querySelectorAll('[data-bp]').forEach((script) => {
            try {
              const data = JSON.parse(script.textContent);
              this.products[data.id] = data;
            } catch (e) {
              /* ignorar */
            }
          });
          html.querySelectorAll('[data-bres-item]').forEach((li) => {
            const id = Number(li.querySelector('h433-quick-add')?.dataset.productId);
            const data = this.products[id];
            if (this.dataset.hideSoldOut === 'true' && data && !data.available) return;
            items.push(li);
          });
          const next = html.querySelector('[data-bres-next]')?.dataset.bresNext || '';
          return { items, next: next ? this.withSection(next) : '' };
        }

        appendItems(items) {
          let grid = this.results.querySelector('.h433-products__grid');
          if (!grid) {
            grid = document.createElement('ul');
            grid.className = 'h433-products__grid';
            grid.setAttribute('role', 'list');
            this.results.appendChild(grid);
          }
          items.forEach((li) => grid.appendChild(document.importNode(li, true)));
        }

        async renderResults() {
          const term = (this.searchInput?.value || '').trim();
          const token = (this.renderToken = (this.renderToken || 0) + 1);
          this.results.innerHTML = '';
          this.moreButton.hidden = true;
          this.status.textContent = this.dataset.loading || '';
          let page = { items: [], next: '' };
          try {
            page = await this.fetchPage(this.urlFor(this.source, term));
            if (!page.items.length && !term && this.source === 'recommended') {
              page = await this.fetchPage(this.urlFor(`collection:${this.dataset.all}`));
            }
          } catch (e) {
            console.error(e);
          }
          if (token !== this.renderToken) return;
          this.status.textContent = page.items.length ? '' : this.dataset.empty || '';
          this.appendItems(page.items);
          this.nextUrl = page.next;
          this.moreButton.hidden = !page.next;
        }

        async loadMore() {
          if (!this.nextUrl || this.loadingMore) return;
          this.loadingMore = true;
          const token = this.renderToken;
          this.moreButton.disabled = true;
          try {
            const page = await this.fetchPage(this.nextUrl);
            if (token !== this.renderToken) return;
            this.appendItems(page.items);
            this.nextUrl = page.next;
          } catch (e) {
            console.error(e);
          } finally {
            this.loadingMore = false;
            this.moreButton.disabled = false;
            this.moreButton.hidden = !this.nextUrl;
          }
        }

        /* ---------- ventana ---------- */
        openPicker(index) {
          this.target = index;
          if (!this.dialog) return;
          this.showBrowse();
          if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
          else this.dialog.setAttribute('open', '');
          document.documentElement.classList.add('h433-bpick-open');
          if (!this.source) {
            const active = this.querySelector('.h433-bpick__chip.is-active') || this.querySelector('.h433-bpick__chip');
            active?.classList.add('is-active');
            this.source = active ? active.dataset.source : `collection:${this.dataset.all}`;
          }
          if (!this.results.children.length) this.renderResults();
        }

        closePicker() {
          if (!this.dialog) return;
          if (typeof this.dialog.close === 'function') this.dialog.close();
          else this.dialog.removeAttribute('open');
          document.documentElement.classList.remove('h433-bpick-open');
        }

        showBrowse() {
          this.config.hidden = true;
          this.browse.hidden = false;
          if (this.browseScroll != null) this.scroller.scrollTop = this.browseScroll;
        }

        /* ---------- talla / manga ---------- */
        optionLabel(name) {
          const n = (name || '').toLowerCase();
          if (n.includes('manga') && this.dataset.sleeveName) return this.dataset.sleeveName;
          if ((n.includes('talla') || n === 'size') && this.dataset.sizeName) return this.dataset.sizeName;
          return name;
        }

        optionValues(product, i) {
          const seen = [];
          product.variants.forEach((v) => {
            const val = v.options?.[i];
            if (val != null && !seen.includes(val)) seen.push(val);
          });
          return seen;
        }

        isDefaultOnly(product) {
          return product.variants.length === 1 && (product.variants[0].title === 'Default Title' || !product.options?.length);
        }

        valueAvailable(i, value) {
          const { product, selected } = this.cfg;
          return product.variants.some(
            (v) => v.available && v.options[i] === value && v.options.every((o, j) => j === i || selected[j] == null || selected[j] === o)
          );
        }

        matchVariant() {
          const { product, selected } = this.cfg;
          if (selected.some((x) => x == null)) return null;
          return product.variants.find((v) => v.options.every((o, j) => o === selected[j])) || null;
        }

        openConfig(product) {
          if (this.isDefaultOnly(product)) {
            const v = product.variants[0];
            if (v && v.available) this.choose(product, v);
            return;
          }
          const options = product.options || [];
          const selected = options.map((_, i) => {
            const values = this.optionValues(product, i);
            return values.length === 1 ? values[0] : null;
          });
          this.cfg = { product, selected, slide: 0, lastVariant: null };
          this.browseScroll = this.scroller.scrollTop;
          this.browse.hidden = true;
          this.config.hidden = false;
          this.renderConfig();
          this.scroller.scrollTop = 0;
        }

        renderConfig() {
          const { product, selected } = this.cfg;
          const variant = this.matchVariant();
          const prices = product.variants.map((v) => v.price);
          const price = variant ? variant.price : Math.min(...prices);
          const images = (product.images && product.images.length ? product.images : [product.image]).filter(Boolean);
          if (variant && variant.image && variant.id !== this.cfg.lastVariant) {
            const k = images.indexOf(variant.image);
            if (k > -1) this.cfg.slide = k;
          }
          this.cfg.lastVariant = variant ? variant.id : null;
          const arrows = this.dataset.arrows !== 'false' && images.length > 1;
          const chevron = (d) =>
            `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${d}"/></svg>`;
          const gallery = `<h433-bpick-gallery class="h433-bpick__cfg-media" data-start="${this.cfg.slide}">
              <div class="h433-bpick__track" data-track>${images
                .map((src, i) => `<div class="h433-bpick__slide" data-slide><img src="${this.esc(src)}" alt="${this.esc(product.title)} ${i + 1}" ${i ? 'loading="lazy"' : ''}></div>`)
                .join('')}</div>
              ${
                arrows
                  ? `<button type="button" class="h433-bpick__arrow h433-bpick__arrow--prev" data-prev aria-label="Foto anterior">${chevron('M15 6l-6 6 6 6')}</button>
                     <button type="button" class="h433-bpick__arrow h433-bpick__arrow--next" data-next aria-label="Foto siguiente">${chevron('M9 6l6 6-6 6')}</button>`
                  : ''
              }
              ${
                images.length > 1
                  ? `<div class="h433-bpick__dots">${images
                      .map((_, i) => `<button type="button" class="h433-bpick__dot" data-dot="${i}" aria-label="Foto ${i + 1} de ${images.length}"></button>`)
                      .join('')}</div>`
                  : ''
              }
            </h433-bpick-gallery>`;
          const missingIndex = selected.findIndex((x) => x == null);

          let buttonText = this.dataset.confirm || 'Agregar';
          let ready = false;
          if (missingIndex > -1) {
            buttonText = (this.dataset.missing || '[opción]').replace(
              '[opción]',
              this.optionLabel(product.options[missingIndex]).toLowerCase()
            );
          } else if (!variant || !variant.available) {
            buttonText = this.dataset.unavailable || this.dataset.soldOut || '';
          } else {
            ready = true;
          }

          const groups = (product.options || [])
            .map((name, i) => {
              const values = this.optionValues(product, i);
              const buttons = values
                .map((val) => {
                  const active = selected[i] === val;
                  const available = this.valueAvailable(i, val);
                  return `<button type="button" class="h433-bpick__value${active ? ' is-active' : ''}${
                    available ? '' : ' is-unavailable'
                  }" data-cfg-opt="${i}" data-cfg-val="${this.esc(val)}" aria-pressed="${active}">${this.esc(val)}</button>`;
                })
                .join('');
              return `<fieldset class="h433-bpick__opt">
                <legend class="h433-bpick__opt-name">${this.esc(this.optionLabel(name))}${
                selected[i] != null ? `: <strong>${this.esc(selected[i])}</strong>` : ''
              }</legend>
                <div class="h433-bpick__values">${buttons}</div>
              </fieldset>`;
            })
            .join('');

          this.config.innerHTML = `<button type="button" class="h433-bpick__back" data-cfg-back>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>
              ${this.esc(this.dataset.back)}
            </button>
            <div class="h433-bpick__cfg">
              ${gallery}
              <div class="h433-bpick__cfg-info">
                <p class="h433-bpick__cfg-name">${this.esc(product.title)}</p>
                <p class="h433-bpick__cfg-price">${this.formatMoney(price)}</p>
                ${this.dataset.configTitle ? `<p class="h433-bpick__cfg-hint">${this.esc(this.dataset.configTitle)}</p>` : ''}
                ${groups}
                <button type="button" class="h433-bundle__cta h433-bpick__confirm" data-cfg-confirm ${ready ? '' : 'disabled'}>${this.esc(buttonText)}</button>
              </div>
            </div>`;
        }

        choose(product, variant) {
          const pick = {
            product: {
              id: product.id,
              title: product.title,
              url: product.url,
              image: product.image,
              options: product.options,
              variants: product.variants,
            },
            variantId: variant.id,
          };
          if (this.target < this.picks.length) this.picks[this.target] = pick;
          else this.picks.push(pick);
          this.closePicker();
          this.render();
        }

        /* ---------- eventos ---------- */
        onPickerClick(e) {
          const t = e.target instanceof Element ? e.target : null;
          if (!t) return;
          const card = t.closest('[data-bres-item]');
          if (!card) return;
          const trigger = t.closest('.h433-add__button, a');
          if (!trigger) return;
          e.preventDefault();
          e.stopPropagation();
          if (trigger.disabled) return;
          const id = Number(card.querySelector('h433-quick-add')?.dataset.productId);
          const product = this.products[id];
          if (product) this.openConfig(product);
        }

        onClick(e) {
          const t = e.target instanceof Element ? e.target : null;
          if (!t) return;

          const open = this.hit(t, '[data-open]');
          if (open) {
            this.openPicker(Number(open.dataset.pick));
            return;
          }

          if (this.hit(t, '[data-close]')) {
            this.closePicker();
            return;
          }

          const chip = this.hit(t, '.h433-bpick__chip');
          if (chip) {
            this.querySelectorAll('.h433-bpick__chip').forEach((c) => c.classList.toggle('is-active', c === chip));
            if (this.searchInput) this.searchInput.value = '';
            this.source = chip.dataset.source;
            this.renderResults();
            return;
          }

          if (this.hit(t, '[data-load-more]')) {
            this.loadMore();
            return;
          }

          if (this.hit(t, '[data-cfg-back]')) {
            this.showBrowse();
            return;
          }

          const opt = this.hit(t, '[data-cfg-opt]');
          if (opt && this.cfg) {
            const i = Number(opt.dataset.cfgOpt);
            const value = opt.dataset.cfgVal;
            const { product, selected } = this.cfg;
            selected[i] = value;
            // Si la combinación no existe, limpia las demás opciones que choquen
            const exists = product.variants.some((v) =>
              v.options.every((o, j) => selected[j] == null || selected[j] === o)
            );
            if (!exists) {
              selected.forEach((_, j) => {
                if (j !== i && this.optionValues(product, j).length > 1) selected[j] = null;
              });
            }
            this.renderConfig();
            return;
          }

          if (this.hit(t, '[data-cfg-confirm]') && this.cfg) {
            const v = this.matchVariant();
            if (v && v.available) this.choose(this.cfg.product, v);
            return;
          }

          const remove = this.hit(t, '[data-remove]');
          if (remove) {
            this.picks.splice(Number(remove.dataset.remove), 1);
            this.render();
            return;
          }

          const cartRemove = this.hit(t, '[data-cart-remove]');
          if (cartRemove) {
            this.removeFromCart(cartRemove.dataset.cartRemove, cartRemove);
            return;
          }

          if (this.hit(t, '[data-cta]')) {
            this.addToCart([this.page, ...this.picks], null, true);
            return;
          }

          const single = this.hit(t, '[data-single]');
          if (single) this.addToCart([this.page], single, false);
        }

        onChange(e) {
          const sel = e.target instanceof HTMLSelectElement ? e.target : null;
          if (sel && sel.dataset.cartSize) {
            this.changeCartVariant(sel.dataset.cartSize, Number(sel.value), sel);
            return;
          }
          if (!sel || !sel.dataset.sizeFor) return;
          const slot = sel.dataset.sizeFor === 'page' ? this.page : this.picks[Number(sel.dataset.sizeFor)];
          if (slot) slot.variantId = Number(sel.value);
          this.render();
        }

        /* ---------- pintar ---------- */
        variantOf(slot) {
          if (!slot) return null;
          return slot.product.variants.find((v) => v.id === slot.variantId) || slot.product.variants[0];
        }

        render() {
          const slotsEl = this.querySelector('[data-slots]');
          const esc = (s) => (s || '').toString().replace(/[<>&"]/g, (c) => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' })[c]);

          const selectHtml = (variants, selectedId, attr) => {
            if (!variants || variants.length < 2) return '';
            const options = variants
              .map(
                (v) =>
                  `<option value="${v.id}" ${v.id === selectedId ? 'selected' : ''} ${v.available || v.id === selectedId ? '' : 'disabled'}>${esc(v.title)}${
                    v.available ? '' : ' — ' + esc(this.dataset.soldOut)
                  }</option>`
              )
              .join('');
            return `<label class="h433-bundle__size"><span>${esc(this.dataset.size)}</span><select ${attr}>${options}</select></label>`;
          };
          const select = (slot, key) => selectHtml(slot.product.variants, slot.variantId, `data-size-for="${key}"`);
          const thumb = (img, alt, removeAttr, removeLabel) =>
            `<div class="h433-bundle__thumb">${img ? `<img src="${esc(img)}" alt="${esc(alt)}" loading="lazy">` : ''}${
              removeAttr ? `<button type="button" class="h433-bundle__remove" ${removeAttr} aria-label="${esc(removeLabel)}">×</button>` : ''
            }</div>`;

          // Todas las piezas del paquete: este jersey + los del carrito + los nuevos
          const prices = [];
          let html = '';

          const v0 = this.variantOf(this.page);
          prices.push(v0 ? v0.price : 0);
          html += `<div class="h433-bundle__slot is-filled">
              ${thumb((v0 && v0.image) || this.page.product.image, this.page.product.title)}
              <p class="h433-bundle__price">${this.formatMoney(v0 ? v0.price : 0)}</p>
              <p class="h433-bundle__tag">${esc(this.dataset.thisLabel)}</p>
              ${select(this.page, 'page')}
            </div>`;

          if (this.showCart) {
            this.cartUnits.forEach(({ item }) => {
              prices.push(item.price);
              const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
              html += `<div class="h433-bundle__slot is-filled is-cart">
                  ${thumb(item.image ? this.sized(item.image, 300) : '', item.product_title, `data-cart-remove="${esc(item.key)}"`, this.dataset.cartRemoveLabel)}
                  <p class="h433-bundle__price">${this.formatMoney(item.price)}</p>
                  <p class="h433-bundle__tag h433-bundle__tag--cart">${esc(this.dataset.cartLabel)}</p>
                  ${
                    this.productCache[item.handle] && this.productCache[item.handle].variants.length > 1
                      ? selectHtml(this.productCache[item.handle].variants, item.variant_id, `data-cart-size="${esc(item.key)}"`)
                      : variant
                        ? `<p class="h433-bundle__variant">${esc(variant)}</p>`
                        : ''
                  }
                </div>`;
            });
          }

          this.picks.forEach((slot, i) => {
            const v = this.variantOf(slot);
            prices.push(v ? v.price : 0);
            html += `<div class="h433-bundle__slot is-filled">
                ${thumb((v && v.image) || slot.product.image, slot.product.title, `data-remove="${i}"`, 'Quitar')}
                <p class="h433-bundle__price">${this.formatMoney(v ? v.price : 0)}</p>
                <button type="button" class="h433-bundle__change" data-open data-pick="${i}">${esc(slot.product.title)}</button>
                ${select(slot, i)}
              </div>`;
          });

          const count = prices.length;
          const missing = (3 - (count % 3)) % 3;
          for (let j = 0; j < missing; j++) {
            html += `<button type="button" class="h433-bundle__slot h433-bundle__slot--empty" data-open data-pick="${this.picks.length}" aria-label="${esc(this.dataset.modalTitle || '+')}">
                <span class="h433-bundle__plus" aria-hidden="true">+</span>
              </button>`;
          }
          slotsEl.innerHTML = html;

          // Aviso cuando ya hay jerseys en el carrito
          const hint = this.querySelector('[data-hint]');
          const inCart = this.showCart ? this.cartUnits.length : 0;
          if (hint) {
            const sets = Math.floor(count / 3);
            let text = '';
            if (inCart > 0) {
              text = missing > 0 && sets > 0 ? this.dataset.hintNext || '' : this.dataset.hintCart || '';
              text = text.replaceAll('[n]', inCart).replaceAll('[faltan]', missing).replaceAll('[gratis]', sets);
            }
            hint.textContent = text;
            hint.hidden = !text;
          }

          // Botón y resumen
          const summary = this.querySelector('[data-summary]');
          const newCount = 1 + this.picks.length;
          if (this.justAdded) {
            this.cta.disabled = true;
            this.cta.textContent = this.dataset.added || '';
          } else if (missing > 0) {
            this.cta.disabled = true;
            this.cta.textContent = this.text(missing === 1 && this.dataset.neededOne ? 'neededOne' : 'needed', missing);
          } else {
            this.cta.disabled = false;
            this.cta.textContent = inCart > 0 && this.dataset.readyCart ? this.text('readyCart', newCount) : this.text('ready', 3);
          }
          if (missing > 0) {
            summary.hidden = true;
          } else {
            const sorted = prices.slice().sort((a, b) => a - b);
            const free = sorted.slice(0, Math.floor(count / 3)).reduce((a, b) => a + b, 0);
            const total = prices.reduce((a, b) => a + b, 0);
            summary.hidden = false;
            summary.innerHTML = `<span class="h433-bundle__total"><s>${this.formatMoney(total)}</s> <strong>${this.formatMoney(total - free)}</strong></span>
              <span class="h433-bundle__save">${esc(this.text('savings', 3, this.formatMoney(free)))}</span>`;
          }
        }

        /* ---------- carrito ---------- */
        sectionIds() {
          return Array.from(document.querySelectorAll('cart-items-component'))
            .map((el) => el.dataset.sectionId)
            .filter(Boolean);
        }

        showMessage(text) {
          const msg = this.querySelector('[data-msg]');
          if (!msg) return;
          msg.textContent = text;
          msg.hidden = false;
          clearTimeout(this.msgTimer);
          this.msgTimer = setTimeout(() => (msg.hidden = true), 4000);
        }

        async addToCart(slots, trigger, isBundle) {
          const button = trigger || this.cta;
          if (this.busy) return;
          const counts = {};
          slots.filter(Boolean).forEach((s) => {
            const v = this.variantOf(s);
            if (v) counts[v.id] = (counts[v.id] || 0) + 1;
          });
          const items = Object.keys(counts).map((id) => ({ id: Number(id), quantity: counts[id] }));
          if (!items.length) return;

          this.busy = true;
          const original = button.textContent;
          button.disabled = true;
          button.textContent = this.dataset.adding || original;
          const sections = this.sectionIds();

          try {
            const res = await fetch(`${this.root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items, ...(sections.length ? { sections: sections.join(',') } : {}) }),
            });
            const data = await res.json();
            if (!res.ok || data.status) throw new Error(data.description || data.message || 'No se pudo agregar');

            if (isBundle) {
              this.picks = [];
              this.justAdded = true;
              this.render();
              setTimeout(() => {
                this.justAdded = false;
                this.render();
              }, 2000);
            } else {
              button.textContent = this.dataset.added || original;
              setTimeout(() => {
                button.textContent = original;
                button.disabled = false;
              }, 2000);
            }
            const event = new Event('cart:update', { bubbles: true });
            event.detail = {
              resource: {},
              sourceId: String(items[0].id),
              data: {
                source: 'h433-bundle',
                itemCount: items.reduce((a, b) => a + b.quantity, 0),
                productId: this.dataset.productId,
                variantId: String(items[0].id),
                sections: data.sections || {},
              },
            };
            this.dispatchEvent(event);
          } catch (error) {
            button.textContent = original;
            button.disabled = false;
            this.showMessage(error.message);
          } finally {
            this.busy = false;
          }
        }
      }
    );
  }

  if (!customElements.get('h433-bpick-gallery')) {
    customElements.define(
      'h433-bpick-gallery',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          this.index = 0;
          if (!this.track) return;
          requestAnimationFrame(() => this.go(Number(this.dataset.start) || 0, false));
          this.addEventListener('click', (e) => {
            const b = e.target instanceof Element ? e.target.closest('[data-prev], [data-next], [data-dot]') : null;
            if (!b) return;
            e.preventDefault();
            e.stopPropagation();
            if (b.hasAttribute('data-dot')) this.go(Number(b.dataset.dot));
            else this.go(this.index + (b.hasAttribute('data-next') ? 1 : -1));
          });
          this.track.addEventListener(
            'scroll',
            () => {
              cancelAnimationFrame(this.frame);
              this.frame = requestAnimationFrame(() => {
                this.mark(Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1)));
              });
            },
            { passive: true }
          );
        }

        go(i, smooth = true) {
          const n = this.slides.length;
          if (!n) return;
          const index = ((i % n) + n) % n;
          this.track.scrollTo({ left: this.track.clientWidth * index, behavior: smooth ? 'smooth' : 'auto' });
          this.mark(index);
        }

        mark(i) {
          this.index = i;
          this.dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
          const host = this.closest('h433-bundle');
          if (host && host.cfg) host.cfg.slide = i;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["h433-mega-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const tab = event.target instanceof Element ? event.target.closest('[data-mega-tab]') : null;
    if (!tab) return;
    const mega = tab.closest('[data-h433-mega]');
    const grid = mega?.querySelector('[data-mega-grid]');
    if (!mega || !grid) return;
    event.preventDefault();
    event.stopPropagation();

    // Mantener la altura para que el menú no "brinque" al filtrar
    if (!grid.style.minHeight) grid.style.minHeight = grid.offsetHeight + 'px';

    const group = tab.dataset.megaTab;
    mega.querySelectorAll('[data-mega-tab]').forEach((t) => {
      const active = t === tab;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', String(active));
    });
    grid.querySelectorAll('[data-mega-group]').forEach((item) => {
      item.hidden = group !== 'all' && item.dataset.megaGroup !== group;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["h433-product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('h433-quick-add')) {
    customElements.define(
      'h433-quick-add',
      class H433QuickAdd extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-add]');
          this.msg = this.querySelector('[data-msg]');
          this.label = this.querySelector('[data-label]');
          if (!this.button) return;
          this.defaultLabel = this.label ? this.label.textContent : '';

          this.button.addEventListener('click', () => {
            // 1) Vista rápida (sección "Vista rápida (Agregar)" del encabezado)
            const qv = window.h433QuickView;
            const json = this.querySelector('script[data-qv-product]');
            if (qv && json) {
              try {
                if (qv.open(JSON.parse(json.textContent))) return;
              } catch (e) {
                console.error(e);
              }
            }
            // 2) Respaldo: un solo modelo -> agregar directo; varias tallas -> ir al producto
            const id = this.button.dataset.variantId;
            if (id) {
              this.add(id, this.button);
            } else if (this.dataset.url) {
              window.location.href = this.dataset.url;
            }
          });
        }

        sectionIds() {
          return Array.from(document.querySelectorAll('cart-items-component'))
            .map((el) => el.dataset.sectionId)
            .filter(Boolean);
        }

        showMessage(text, isError) {
          if (!this.msg) return;
          this.msg.textContent = text;
          this.msg.hidden = false;
          this.msg.classList.toggle('is-error', Boolean(isError));
          clearTimeout(this.msgTimer);
          this.msgTimer = setTimeout(() => (this.msg.hidden = true), 3500);
        }

        async add(variantId, trigger) {
          if (!variantId || this.busy) return;
          this.busy = true;
          trigger?.classList.add('is-loading');
          this.button.disabled = true;
          if (this.label) this.label.textContent = 'Agregando…';

          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const sections = this.sectionIds();

          try {
            const response = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [{ id: Number(variantId), quantity: 1 }],
                ...(sections.length ? { sections: sections.join(',') } : {}),
              }),
            });
            const data = await response.json();

            if (!response.ok || data.status) {
              throw new Error(data.description || data.message || 'No se pudo agregar');
            }

            if (this.label) this.label.textContent = '¡Agregado!';
            this.classList.add('is-added');

            const event = new Event('cart:update', { bubbles: true });
            event.detail = {
              resource: {},
              sourceId: String(variantId),
              data: {
                source: 'h433-quick-add',
                itemCount: 1,
                productId: this.dataset.productId,
                variantId: String(variantId),
                sections: data.sections || {},
              },
            };
            this.dispatchEvent(event);

            setTimeout(() => {
              if (this.label) this.label.textContent = this.defaultLabel;
              this.classList.remove('is-added');
            }, 2000);
          } catch (error) {
            if (this.label) this.label.textContent = this.defaultLabel;
            this.showMessage(error.message, true);
          } finally {
            this.busy = false;
            this.button.disabled = false;
            trigger?.classList.remove('is-loading');
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
